import React, { useState, useRef, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  Box,
  Button,
  CircularProgress,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  IconButton,
  TextField,
  Typography,
  useMediaQuery
} from "@material-ui/core"
import ManageTags from "./ManageTags"
import UpdateEmail from "./UpdateEmail"
import { useTheme } from "@material-ui/core/styles"
import useStyles from "./styles"

const ManageTagsDialog = ({
  openDialog,
  toggleDialog,
  setSelectedEmail,
  selectedEmail
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { id, tags = [] } = useSelector(state => state.organization.currentOrg)
  const inputRef = useRef()
  const [loading, setLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState([])
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))

  return (
    <Dialog
      className={classes.dialogsContainerDialog}
      classes={{
        paper: classes.paper
      }}
      open={openDialog}
      onClose={() => {
        setSelectedEmail()
        toggleDialog()
      }}
      fullScreen={fullScreen}
    >
      <DialogContent className={classes.header} id="responsive-dialog-title">
        <Typography variant="h3" className={classes.headerTitle}>
          {selectedEmail && selectedEmail.id ? "Update Email" : "Manage tags"}
        </Typography>
        <Button
          className={classes.closeButton}
          variant="text"
          onClick={() => {
            setSelectedEmail()
            toggleDialog()
          }}
        >
          Close
        </Button>
      </DialogContent>
      {selectedEmail && selectedEmail.id ? (
        <UpdateEmail
          selectedEmail={selectedEmail}
          setSelectedEmail={setSelectedEmail}
          toggleDialog={toggleDialog}
        />
      ) : (
        <Fragment>
          <DialogContent>
            <ManageTags />
          </DialogContent>
        </Fragment>
      )}
    </Dialog>
  )
}

export default ManageTagsDialog



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationEmail/ManageTagsDialog/index.jsx